import React from 'react';
import { User, Clock, LogOut, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './Header.css';

const Header = ({ 
  title, 
  subtitle, 
  onRefresh, 
  loading = false, 
  lastUpdated = new Date(),
  showBackButton = true,
  backPath = '/menu'
}) => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const [currentTime, setCurrentTime] = React.useState(new Date());

  React.useEffect(() => {
    // Update time every second
    const timeInterval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timeInterval);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { 
      hour12: false, 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit' 
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', { 
      month: '2-digit', 
      day: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  // Generate initials from user name
  const generateInitials = (fullName) => {
    if (!fullName) return 'U';
    const nameParts = fullName.trim().split(' ');
    if (nameParts.length >= 2) {
      return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
    } else if (nameParts.length === 1) {
      return nameParts[0][0].toUpperCase();
    }
    return 'U';
  };

  return (
    <div className="header-top">
      <div className="header-left">
        {showBackButton && (
          <button onClick={() => navigate(backPath)} className="back-button">
            ⬅️
          </button>
        )}
        <div className="header-content">
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
      </div>
      
      <div className="header-right">
        <div className="header-info">
          <User size={14} />
          <span>{user ? generateInitials(user.fullName || user.name || user.username) : 'U'}</span>
        </div>
        <div className="header-time">
          <Clock size={14} />
          <span>{formatTime(currentTime)}</span>
        </div>
        <div className="header-time last-updated">
          <span>Last updated: {formatDate(lastUpdated)}</span>
        </div>
        {onRefresh && (
          <button onClick={onRefresh} className="header-action-btn">
            {loading ? (
              <div className="header-spinner"></div>
            ) : (
              <RefreshCw size={16} />
            )}
          </button>
        )}
        <button onClick={handleLogout} className="header-action-btn logout">
          <LogOut size={16} />
        </button>
      </div>
    </div>
  );
};

export default Header;
